import { t } from '@/helper/i18n-utils';

const state = {
    notifications: []
};

const mutations = {
    SHOW_NOTIFICATION(state, res) {
        let notification = { type: res.type, text: '' };

        if (typeof res.response === 'string') {
            notification.text = res.response;
        } else {
            const status = res.response?.status;
            const data = res.response?.data;
    
            notification.text = data?.message || data?.detail || data?.error
                || (data?.password ? data?.password[0] : data?.password)
                || (data?.new_password ? data?.new_password[0] : data?.new_password)
                || (data?.email ? 'Email: ' + data?.email[0] : data?.email)
                || t('notifications.general_error');
    
            if (status === 500) {
                notification.text = t('notifications.general_error');
            }
            if (status === 401) {
                notification.text = notification.text + ' ' + t('notifications.need_auth');
            }
            if (status === 404) {
                notification.text = t('notifications.wrong_path');
            }
        }
    
        state.notifications.push(notification);
    
        setTimeout(() => {
            state.notifications = [];
        }, 5000);
    }    
};

const actions = {
    showNotification({ commit }, response) {
        commit('SHOW_NOTIFICATION', response);
    }
};

const getters = {
    notifications: state => state.notifications
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
